import { produce } from 'immer';

import { CloseCampaignServiceEditor } from '../../actions/campaignServiceEditor/closeCampaignServiceEditor';
import { CampaignServiceEditorState } from '../../typings/campaignServiceEditor';

export function closeCampaignServiceEditor(
    state: CampaignServiceEditorState,
    action: CloseCampaignServiceEditor
): CampaignServiceEditorState {
    return produce(state, draft => {
        const { editorId } = action;

        draft[editorId].isOpen = false;
    });
}
